<template>
    <v-list
            one-line
            class="pa-0"
    >
        <v-list-group value="true">
            <v-list-tile slot="item">
                <v-list-tile-content>
                    <v-list-tile-title>Link your personal data vault</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon>keyboard_arrow_down</v-icon>
                </v-list-tile-action>
            </v-list-tile>
            <v-list-tile
                    avatar
                    ripple
                    v-for="provider in limitedProviderList"
                    :key="provider.Code"
                    @click="linkProvider(provider.Code)"
            >
                <v-list-tile-avatar>
                    <v-icon
                            :class="[provider.Code]"
                    >
                        fa-{{provider.Code}}
                    </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title v-text="provider.Name"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-list-tile-action-text><div :class="statusClass(provider.Code)">{{ status(provider.Code) }}</div></v-list-tile-action-text>
                </v-list-tile-action>
            </v-list-tile>
        </v-list-group>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex';
    import userReadable from '@/utils/time';

    export default {
        name: 'me-datastore-connections',
        data() {
            return {};
        },
        computed: {
            ...mapGetters('datastoreProviders', [
                'limitedProviderList',
            ]),
            ...mapGetters('profile', [
                'datastoreConnections',
            ]),
        },
        methods: {
            statusClass(providerCode) {
                const connection = this.connection(providerCode);
                if (connection && connection.RequiresReauthentication) {
                    return 'status important';
                }

                return 'status';
            },
            status(providerCode) {
                const connection = this.connection(providerCode);
                if (!connection) {
                    return 'not connected';
                }

                if (connection.RequiresReauthentication) {
                    return 'requires reauthentication';
                }

                if (connection.AccessTokenExpiration) {
                    if (connection.AccessTokenExpiration === '0001-01-01T00:00:00Z') {
                        return 'never expires';
                    }

                    return `expires on ${userReadable(connection.AccessTokenExpiration)}`;
                }

                return 'connected';
            },
            connection(providerCode) {
                for (let i = 0; i < this.datastoreConnections.length; i += 1) {
                    const connection = this.datastoreConnections[i];
                    if (connection.DataStoreProviderId === providerCode) {
                        return connection;
                    }
                }

                return undefined;
            },
            linkProvider(providerCode) {
                const provider
                    = this.limitedProviderList.find(element => element.Code === providerCode);

                if (provider) {
                    this.$store.dispatch('profile/AUTHORIZE_DATASTORE_CONNECTION', provider);
                } else {
                    const error = new Error(`Provider with code ${providerCode} was not found in limited list of profile providers!`);
                    this.$store.dispatch('errors/ADD', error);
                }
            },
        },
        created() {
            this.$store.dispatch('profile/LIST_DATASTORE_CONNECTIONS');
            this.$store.dispatch('datastoreProviders/LIST_ALL');
        },
    };
</script>

<style lang="stylus" scoped>
    .avatar
        .icon.dropbox
            color white
            background-color #0061FF
</style>


// WEBPACK FOOTER //
// DatastoreConnections.vue?763ab66c